import { SET_FEATURE_FLAGS } from './actionTypes';
import { FeatureFlags } from '@/src/types/featureFlags';

export const setFeatureFlags = (payload: FeatureFlags) => ({
  type: SET_FEATURE_FLAGS,
  payload,
});
